const locale: Locale = {
  ko: {
    capslock: 'Caps Lock이 켜져있습니다.',
    check: '이메일 혹은 비밀번호를 확인해주세요.',
    signin: '로그인',
    email: '지스트 이메일을 입력하세요',
    password: '비밀번호를 입력하세요',
    forgotPwd: '비밀번호를 잊으셨나요?',
    signupMsg: '계정이 없으신가요?',
    signup: '회원가입',
  },
  en: {
    capslock: 'Caps Lock is On.',
    check: 'Please check your details and try again.',
    signin: 'Sign In',
    email: 'GIST e-mail',
    password: 'password',
    forgotPwd: 'Forgot password?',
    signupMsg: "Don't have an account?",
    signup: 'Sign Up',
  },
}

export default locale
